import { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import { api, fmtDate } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageHeader, StatusPill } from "../../components/common";
import TrainingRequestForm from "../../components/TrainingRequestForm";

const PILL = { new: "pending", contacted: "in_progress", scheduled: "shortlisted", closed: "done" };

export default function TrainStaff() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const load = () => api.get("/employer/training-requests").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div>
      <PageHeader eyebrow="Corporate training" title="Train your staff" subtitle="Request Lean Six Sigma Yellow, Green or Black Belt training for your team. Dexterity Consult will contact you with a proposal." />
      <div className="grid lg:grid-cols-12 gap-5">
        <div className="lg:col-span-7 dx-card p-6"><TrainingRequestForm user={user} onSent={load} /></div>
        <div className="lg:col-span-5 dx-card p-6" data-testid="employer-training-requests">
          <h3 className="font-display font-semibold text-lg mb-3">Your requests</h3>
          {rows.length === 0 ? <p className="text-sm text-[#6b5a73] flex gap-2"><GraduationCap className="w-4 h-4 text-[#D4AF37]" />No requests yet.</p> : rows.map((r) => (
            <div key={r.id} className="py-3 border-b last:border-0 flex justify-between gap-3" data-testid={`employer-treq-${r.id}`}>
              <div><div className="font-semibold text-sm">{r.training}</div><div className="text-xs text-[#6b5a73]">{r.staff_count} staff · {r.mode} · {fmtDate(r.created_at)}</div></div>
              <StatusPill status={PILL[r.status]} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
